/* eslint-disable */
import { Dialog } from 'vant'
import { wxShare } from '../assets/js/tools'
import {
    getAppVersion,
    getMobileInfo,
    getNetworkType,
    getSessionKey,
    setSessionKey
} from '../assets/js/util'

// 分享
export const share = {
    data() {
        return {}
    },
    beforeCreate() {},
    created() {},
    mounted() {},
    methods: {
        getWechatConfig(opt) {
            /**
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        getLocation: true // 是否获取用户地理位置
        noSetShare: false  // 不设置分享  默认false开启分享  true不开启分享（与获取地理位置区分）
      */
            // 获取wx配置
            const data = {
                type: 4,
                url: window.location.href
            }
            this.$http({
                url: `/wechat/configure`,
                data,
                loading: false
            })
                .then((res) => {
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: res.data.appId, // 必填，公众号的唯一标识
                        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                        nonceStr: res.data.noncestr, // 必填，生成签名的随机串
                        signature: res.data.signature, // 必填，签名
                        jsApiList: [
                            'onMenuShareAppMessage',
                            'onMenuShareTimeline',
                            'updateAppMessageShareData',
                            'updateTimelineShareData',
                            'hideMenuItems',
                            'scanQRCode',
                            'getLocation'
                        ] // 必填，需要使用的JS接口列表
                    })
                    return true
                })
                .then((res) => {
                    if (!res) return
                    if (!opt.noSetShare) {
                        this.wxShareImg(opt)
                    }
                })
        },
        wxShareImg(opt) {
            wx.ready(() => {
                console.log('走进分享代码')
                // 分享给朋友
                wx.updateAppMessageShareData(opt)

                console.log('share =>', opt)

                // 朋友圈分享
                wx.onMenuShareTimeline({
                    ...opt,
                    success: () => {}
                })
            })
        }
    }
}

export const commonMixin = {
    data() {
        const _obj = getSessionKey()
        return {
            BASE_USERINFO: _obj,
            isHasNickname: !!_obj.nickname,
            isHasAvatar: !!_obj.avatar,
            isHasAddress: !!_obj.cityName && !!_obj.provinceName && !!_obj.province && !!_obj.city
        }
    },
    created() {
        this.MIXINS_INIT()
    },
    mounted() {
        this.MIXINS_INIT()
    },
    methods: {
        MIXINS_INIT() {
            const _userinfo = getSessionKey()
            this.BASE_USERINFO = _userinfo
            this.isHasNickname = !!_userinfo.nickname
            this.isHasAvatar = !!_userinfo.avatar
            this.isHasAddress =
                !!_userinfo.cityName &&
                !!_userinfo.provinceName &&
                !!_userinfo.province &&
                !!_userinfo.city
        },
        SET_USERINFO(params = {}) {
            const _userinfo = {
                ...this.BASE_USERINFO,
                ...params
            }
            setSessionKey(_userinfo)
            this.MIXINS_INIT()
        },
        WX_SHARE(opt) {
            wxShare(opt)
        },
        CHECK_USERINFO(cb = () => {}) {
            const _userinfo = getSessionKey()
            let isHasNickname = !!_userinfo.nickname
            let isHasAvatar = !!_userinfo.avatar
            if (isHasNickname && isHasAvatar) return true
            Dialog.confirm({
                message: '内容需要头像和昵称，是否去填写'
            })
                .then(() => {
                    this.$router.push({
                        path: 'EditPage',
                        query: {
                            returnType: 'userInfo'
                        }
                    })
                })
                .catch(() => {
                    cb(false)
                })
        },
        CHECK_ADDRESS(cb = () => {}) {
            const _userinfo = getSessionKey();
            let isHasAddress =
                !!_userinfo.cityName &&
                !!_userinfo.provinceName &&
                !!_userinfo.province &&
                !!_userinfo.city
            if (isHasAddress) return true
            Dialog.confirm({
                message: '内容需要地址，是否去填写'
            })
                .then(() => {
                    cb(true)
                    this.$router.push({
                        path: 'EditPage',
                        query: {
                            returnType: 'address'
                        }
                    })
                })
                .catch(() => {
                    cb(false)
                })
        },
        // 记录页面滚动的位置
        SET_PAGE_POSTION(key, data) {
            localStorage.setItem(key, JSON.stringify(data))
        },
        // 记录页面滚动的位置
        GET_PAGE_POSTION(key) {
            if (localStorage.getItem(key)) {
                return JSON.parse(localStorage.getItem(key))
            }
            return ''
        },
        CLEAR_PAGE_POSTION(key, data) {
            localStorage.removeItem(key)
        }
    }
}

// 上报
export const report = {
    data() {
        return {}
    },
    beforeCreate() {},
    created() {},
    mounted() {},
    methods: {
        reportData(plateFrom) {
            if (!plateFrom) {
                this.$toast.error('缺少 plateFrom 参数')
                return
            }
            const uaInfo = getMobileInfo()
            const appVersion = getAppVersion()
            let data = {
                actionKey: plateFrom,
                deviceInfo: {
                    os_name: uaInfo.os,
                    phone_model: uaInfo.model,
                    version: appVersion.version,
                    connection: getNetworkType(),
                    href: window.location.href
                }
            }

            this.$http({
                method: 'post',
                url: '/sys/customerVisitorRecord',
                data,
                loading: false,
                mixnisQuery: true
            })
        }
    }
}

// 微信支付
export const wechat = {
    data() {
        return {}
    },
    beforeCreate() {},
    created() {},
    mounted() {},
    methods: {
        // h5微信支付
        weixinPay: function (data) {
            var vm = this
            if (typeof WeixinJSBridge == 'undefined') {
                //微信浏览器内置对象。参考微信官方文档
                if (document.addEventListener) {
                    document.addEventListener('WeixinJSBridgeReady', vm.onBridgeReady(data), false)
                } else if (document.attachEvent) {
                    document.attachEvent('WeixinJSBridgeReady', vm.onBridgeReady(data))
                    document.attachEvent('onWeixinJSBridgeReady', vm.onBridgeReady(data))
                }
            } else {
                vm.onBridgeReady(data)
            }
        },
        // 桥接成功后去支付
        onBridgeReady: function (data) {
            var that = this
            let wxData = JSON.parse(data.payUrl)
            WeixinJSBridge.invoke(
                'getBrandWCPayRequest',
                {
                    debug: true,
                    appId: wxData.appId, //公众号名称，由商户传入
                    timeStamp: wxData.timeStamp, //时间戳，自1970年以来的秒数
                    nonceStr: wxData.nonceStr, //随机串
                    package: wxData.package,
                    signType: wxData.signType, //微信签名方式：
                    paySign: wxData.paySign, //微信签名
                    //这里的信息从后台返回的接口获得。
                    jsApiList: ['chooseWXPay']
                },
                function (res) {
                    // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                    if (res.err_msg == 'get_brand_wcpay_request:ok') {
                        that.checkOrder()
                    }
                }
            )
        },
        checkOrder() {
            if (this.poolTime >= 10) return
            this.poolTime += 1

            const data = {
                orderId: this.orderId
            }

            this.$http({
                url: '/insurance/order/payResult',
                data,
                errorMsg: true
            }).then((res) => {
                if (res.data.status === 2) {
                    this.$toast.success('支付成功')
                    setTimeout(() => {
                        // 支付成功回调
                        this.handleNext()
                    }, 2000)
                } else {
                    setTimeout(() => {
                        this.checkOrder()
                    }, 1000)
                }
            })
        }
    }
}
//页面特殊参数
export const addMoreParams = {
    methods: {
        getOtherInfo() {
            let obj = {}
            Object.keys(this.$route.query).forEach((key) => {
                if (this.$route.query[key]) {
                    obj[key] = this.$route.query[key]
                }
            })
            return obj
        }
    }
}
